import { render, staticRenderFns } from "./ModalBulkInputKasVirtual.vue?vue&type=template&id=150e85fb&scoped=true&"
import script from "./ModalBulkInputKasVirtual.vue?vue&type=script&lang=js&"
export * from "./ModalBulkInputKasVirtual.vue?vue&type=script&lang=js&"
import style0 from "./ModalBulkInputKasVirtual.vue?vue&type=style&index=0&id=150e85fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150e85fb",
  null
  
)

export default component.exports